import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rcp-modal-footer',
  styles: `
    :host {
      z-index: 99;
      position: sticky;
      bottom: 0;
      display: block;
      padding: var(--modal-padding);
      background-color: var(--col-bg-base);
      border-top: 1px solid var(--col-lines);
    }
  `,
  template: ` <ng-content></ng-content> `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ModalFooterComponent {}
